__turbopack_context__.v({
  "buyNowButton": "CTAComponent-module__lVfiPW__buyNowButton",
  "ctaButton": "CTAComponent-module__lVfiPW__ctaButton",
  "ctaLink": "CTAComponent-module__lVfiPW__ctaLink" + " " + __turbopack_context__.i(931616)["ctaStyle"],
  "flatButton": "CTAComponent-module__lVfiPW__flatButton",
  "flatLink": "CTAComponent-module__lVfiPW__flatLink",
  "primaryCta": "CTAComponent-module__lVfiPW__primaryCta",
  "secondaryButton": "CTAComponent-module__lVfiPW__secondaryButton",
  "secondaryCta": "CTAComponent-module__lVfiPW__secondaryCta",
});
